<template>
  <div class="homepage-recommand-cruises">
    <h2 class="cruise-title">限时抢购</h2>
    <ul class="cruise-nav cruise-comm">
      <li
        v-for="(category, i) in cruiseCategories"
        :key="i"
        :class="{ active: currentIndex == i }"
        style="width: 109px"
        @click="onCategoryClick(i)"
      >
        {{ category.name }}
      </li>
    </ul>
    <ul
      v-for="(category, i) in cruiseCategories"
      :key="i"
      class="cruise-content cruise-comm"
      :class="{ active: currentIndex == i }"
    >
      <li
        v-for="(item, index) in getCruiseItems(category.id)"
        :key="index"
        class="cruise_link"
        @click="
          onCruiseClick(
            $event,
            item.cruiseViewModel.shipCode,
            item.cruiseViewModel.sailDate,
            item.cruiseViewModel.isRow,
						index
          )
        "
        :class="{ 'f-dn': item.cruiseCategoryId != category }"
      >
        <div class="img-wrapper">
          <img :src="item.image" />
          <!-- countdown -->
          <HomeCountDown
            :countDownNum="getCountDown(item)"
            v-if="isShowCountDown(item)"
            :className="'timing'"
          />
          <div v-if="item.tag && item.tag.length > 0" class="bg-tag">
            {{ item.tag }}
          </div>
          <img
            v-if="item.isInWishList"
            class="img-soucang heart inWishList"
            src="https://resource.rcclchina.com.cn/homePage/heart.png"
            @click="onWishListClick($event, item)"
          />
          <img
            v-if="!item.isInWishList"
            class="img-soucang heart notInWishList"
            src="https://resource.rcclchina.com.cn/homePage/nullHeart.png"
            @click="onWishListClick($event, item)"
          />
        </div>
        <div class="cruise-intro">
          <div class="intro-title">
            {{ getCruiseName(item) }}
          </div>
          <div class="intro-dataTime intro-comm">{{ getSailDate(item) }}</div>
          <div class="intro-shipName intro-comm">
            {{ item.shipName }}&nbsp;&nbsp;|&nbsp;{{ getRouteNight(item) }}
          </div>
          <div class="intro-price" v-if="item.price > 0">
            {{ item.isNrp ? "早订特惠价" : "限时优惠价" }}
            <span class="tag">￥</span>
            <span class="num">{{ item.price.toFixed(0) }}</span
            >/人起
          </div>
          <div v-if="item.price <= 0" class="intro-comm">售罄</div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import _ from "lodash";
const HomeCountDown = () => import("@/components/Home/HomeCountDown");
import api from "@/api";
import { gioAdsTracking } from "@/utilities/tools";
export default {
  name: "HomeRecommendCruise",
  components: {
    HomeCountDown,
  },
  props: {
    cruiseCategories: {
      type: Array,
      default: () => {
        return [];
      },
    },
    promoCruiseItems: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      currentIndex: 0,
    };
  },
  methods: {
    getCruiseItems(categoryId) {
      let cruiseItems = this.promoCruiseItems.filter(
        (item) => item.cruiseCategoryId == categoryId && item.cruiseViewModel
      );
      cruiseItems = _.orderBy(cruiseItems, "sortNumber", "desc");
      return cruiseItems.slice(0, 2);
    },
    onCruiseClick(e, shipCode, sailDate, isRow, index) {
      e.stopPropagation();
      sailDate = sailDate.split("T")[0];
			let url = isRow ? `${process.env.VUE_APP_TUI_URL}/Cruise/MobileCruiseDetail?sailDate=${sailDate}&shipCode=${shipCode}`
			: `${process.env.VUE_APP_BASE_URL}/Rccl.Cruise/CruiseDetail?sailDate=${sailDate}&shipCode=${shipCode}`;
			const eventObject = {
				"adsType": "ls",
				"lsCatOrder": this.currentIndex+1,
				"lsItmOrder": index+1,
				"desUrl": url
			}
			gioAdsTracking(eventObject);
      if (isRow) {
        window.location.href = url;
      } else {
        this.$router.push({
          name: "CruiseDetail",
          query: { shipCode: shipCode, sailDate: sailDate },
        });
      }
    },
    getCruiseName(item) {
      let cruiseName = item.cruiseViewModel.cruiseRoute;
      if (cruiseName > 49) {
        cruiseName = cruiseName.substr(0, 49) + "..";
      }
      return cruiseName;
    },
    getRouteNight(item) {
      const sailDays = item.cruiseViewModel.sailDays;
      return `${sailDays}天${sailDays - 1}晚`;
    },
    getSailDate(item) {
      let sailDateBegin = item.sailDateBegin.split(" (")[0];
      let sailDateEnd = item.sailDateEnd.split(" (")[0];
      return `${sailDateBegin} - ${sailDateEnd}`;
    },
    isShowCountDown(item) {
      let now = new Date();
      const endTime = item.promoEndTime;
      const moreDate = now.setTime(now.getTime() + 72 * 60 * 60 * 1000);
      let checkEndTime = 0;
      if (item.isShowCountDown && endTime && endTime.length > 0) {
        checkEndTime = new Date(endTime.replace("T", " ")).getTime();
        return checkEndTime < moreDate;
      }
      return false;
    },
    getCountDown(item) {
      const endTime = item.promoEndTime;
      let checkEndTime = 0;
      if (endTime && endTime.length > 0) {
        checkEndTime = new Date(endTime.replace("T", " ")).getTime();
      }
      return checkEndTime;
    },
    onCategoryClick(index) {
      this.currentIndex = index;
			const eventObject = {
				"adsType": "ls",
				"lsCatOrder": index+1
			}
			gioAdsTracking(eventObject);
    },
    onWishListClick(e, cruise) {
      e.stopPropagation();
      if (cruise.isInWishList) {
        this.deleteWishList(cruise);
      } else {
        this.addWishList(cruise);
      }
    },
    async addWishList(cruise) {
      const userToken = this.$store.state.user.userToken;
      if (!userToken || userToken.length == 0) {
        let self = this;
        this.$confirm.show("您尚未登录， 请登录之后， 再添加至心愿单", {
          confirmCallBack: () => {
            self.$router.push({
              name: "Login",
              query: {
                returnUrl: location.href,
              },
            });
          },
        });
        return;
      }
      const requestData = {
        userName: userToken,
        cruiseId: cruise.cruiseViewModel.cruiseId,
        source: "mobile",
      };
      this.$loading.show();
      const { success } = await api.cruise.addWishList(requestData);
      if (success) {
        cruise.isInWishList = true;
      }
      this.$loading.hide();
    },
    async deleteWishList(cruise) {
      const userToken = this.$store.state.user.userToken;
      if (!userToken || userToken.length == 0) {
        let self = this;
        this.$confirm.show("您尚未登录， 请登录之后， 再添加至心愿单", {
          confirmCallBack: () => {
            self.$router.push({
              name: "Login",
              query: {
                returnUrl: location.href,
              },
            });
          },
        });
        return;
      }
      const requestData = {
        userName: userToken,
        cruiseId: cruise.cruiseViewModel.cruiseId,
        source: "mobile",
      };
      this.$loading.show();
      const { success } = await api.cruise.deleteWishList(requestData);
      if (success) {
        cruise.isInWishList = false;
      }
      this.$loading.hide();
    },
  },
  computed: {},
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  list-style: none;
  
  text-transform: uppercase;
}
img {
  display: block;
}

/*限时抢购*/
.homepage-recommand-cruises {
  margin-bottom: 25px;
  /*padding-top: 31px;*/
}
.homepage-recommand-cruises .cruise-title {
  font-size: 23px;
  font-weight: bold;
  color: #282b2c;
  line-height: 62px;
  text-align: center;
}
.homepage-recommand-cruises .cruise-comm {
  width: 345px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.homepage-recommand-cruises .cruise-nav {
  margin-bottom: 12px;
}
.homepage-recommand-cruises .cruise-nav li {
  width: 165px;
  height: 49px;
  font-size: 15px;
  font-weight: bold;
  text-align: center;
  line-height: 49px;
  border: 1px solid #d3dadd;
  margin-bottom: 8px;
  border-radius: 4px;
  background-color: #fff;
  box-shadow: 0px 6px 24px 0px rgba(0, 115, 187, 0.12);

  color: rgb(40, 43, 44);
}
.homepage-recommand-cruises .cruise-nav li.active {
  background-color: rgb(84, 163, 222);
  color: #fff;
}
.homepage-recommand-cruises .cruise-content {
  display: none;
}
.homepage-recommand-cruises .cruise-content.active {
  display: flex;
}
.homepage-recommand-cruises .cruise-content li {
  width: 168px;
  margin-bottom: 18px;
}
.homepage-recommand-cruises .cruise-content li .img-wrapper {
  position: relative;
}
.homepage-recommand-cruises .cruise-content li .img-wrapper .timing {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 27px;
  background-color: rgba(0, 0, 0, 0.5);
  color: #ffa70d;
  font-size: 12px;
  text-align: center;
  line-height: 27px;
}
.cruise-content li .img-wrapper .timing > span {
  color: inherit;
  font-size: 23px;
  font-weight: bold;
}
.cruise-content li .img-wrapper .bg-tag {
  position: absolute;
  top: 0;
  left: -3px;
  background: url("https://resource.rcclchina.com.cn/homePage/mobile/bg.png")
    no-repeat;
  width: 92px;
  height: 23px;
  font-size: 12px;
  font-weight: 400;
  line-height: 23px;
  text-align: center;
  color: #fff;
}
.cruise-content li .img-wrapper .img-soucang {
  position: absolute;
  right: 11px;
  top: 11px;
  width: 27px;
  height: 23px;
}
.homepage-recommand-cruises .cruise-content li img {
  width: 168px;
  display: block;
}
.homepage-recommand-cruises .cruise-content li .cruise-intro {
  padding: 6px 10px 0 0;
}
.cruise-content li .cruise-intro .intro-title {
  font-size: 15px;
  font-weight: 400;
  color: #282b2c;
  line-height: 20px;
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.cruise-content li .cruise-intro .intro-comm {
  font-size: 12px;
  line-height: 19px;
  color: #a0a6a7;
}
.cruise-content li .cruise-intro .intro-price {
  font-size: 12px;
  color: rgb(255, 167, 13);
}
.cruise-content li .cruise-intro .intro-price .num {
  font-weight: bold;
  font-size: 22px;
  color: inherit;
  margin-left: -5px;
}
.cruise-content li .cruise-intro .intro-price .tag {
  font-weight: bold;
  margin-left: -4px;
}
</style>
